module.exports = __webpack_public_path__ + "img/message_fit.14aeb917.svg";